import React from "react"
import LinkBox from "./LinkBox"
import styled from "styled-components"

export default function LinkBoxes(props) {
  const { boxes, ...rest } = props
  return (
    <Container {...rest}>
      {boxes &&
        boxes.map((box, index) => {
          return <LinkBox {...box} count={boxes.length} key={index} />
        })}
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 30px;
`
